"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// office-ui-fabric-react@6.210.6
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
var set_version_1 = require("@uifabric/set-version");
set_version_1.setVersion('office-ui-fabric-react', '6.210.6');
//# sourceMappingURL=version.js.map